"use strict";var toLength=require("../internals/to-length");module.exports=function(obj){return toLength(obj.length)};